import { getProblemList, getProblemTotal } from '@/api/api_problemList'

// 问题列表

const state = {
  problemData: [],
  pageIndex: 1,
  rows: 20,
  total: 20
}

const mutations = {
  SET_PROBLEM_DATA: (state, data) => {
    state.problemData = data
  },
  SET_PAGE_INDEX: (state, pageIndex) => {
    state.pageIndex = pageIndex
  },
  SET_ROWS: (state, rows) => {
    state.rows = rows
  },
  SET_TOTAL: (state, total) => {
    state.total = total
  }
}

const actions = {
  actions_getProblemList ({ commit }, [problemMain, problemGuid, keywords, title, qt, pageIndex, rows]) {
    return new Promise((resolve, reject) => {
      getProblemList(problemMain, problemGuid, keywords, title, qt, pageIndex, rows).then(response => {
        const data = response.data
        if (data.isOk) {
          commit('SET_PROBLEM_DATA', data.data)
          resolve()
        } else {
          reject(data.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  actions_getProblemTotal ({ commit }, [problemMain, problemGuid, keywords, title, qt]) {
    return new Promise((resolve, reject) => {
      getProblemTotal(problemMain, problemGuid, keywords, title, qt).then(response => {
        const data = response.data
        console.log('actions_getProblemTotal->response.data=====', JSON.stringify(data))
        if (data.isOk) {
          commit('SET_TOTAL', data.total)
          resolve()
        } else {
          reject(data.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

const getters = {
  problemList: state => state.problemData,
  pageIndex: state => state.pageIndex,
  rows: state => state.rows,
  total: state => state.total
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/problemListData.js